import { FilterDef } from "@/stores/filters/FilterDef";
import {FilterParamValue} from "@/stores/filters/FilterParamValue";
import { DateTime } from "luxon";

export class PupilFilterDef extends FilterDef {
	constructor() {
		super(['firstName', 'lastName', 'birthdate', 'classroomIds']);
	}

	get firstName(): string | null {
		return this.getParamValues('firstName')[0]?.id.toString() || null
	}
	
	set firstName(value: string) {
		this.setParamValue('firstName', value);
	}

	get lastName(): string | null {
		return this.getParamValues('lastName')[0]?.id.toString() || null
	}
	
	set lastName(value: string) {
		this.setParamValue('lastName', value);
	}

	get dateOfBirth(): string | null {
		return this.getParamValues('birthdate')[0]?.id.toString();
	}

	set dateOfBirth(date: Date) {
		const dateTime = DateTime.fromJSDate(date);
		const iso = dateTime.toUTC().toISODate();

		if (iso) {
			this.setParamValue('birthdate', iso);
		}
	}

	get classroomIds(): string[] {
		return this.getParamValues('classroomIds').map(v => v.id.toString());
	}

	set classroomIds(classroomIds: string[]) {
		this.setParamValues('classroomIds', classroomIds.map(id => new FilterParamValue(id, id)));
	}
}
